<template>
  <div>
    <HeroSection />
    <MainSection />
  </div>
</template>
<script>
import HeroSection from "../components/HeroSection.vue";
import MainSection from "../components/MainSection.vue";

const ORGANIZATION_SCHEMA_ID = "organization-schema-home";

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Gloveler",
  url: "https://gloveler.com/",
  logo: "https://gloveler.com/logo.png",
  description:
    "Book and offer private and affordable accommodations for travelers worldwide.",
  telephone: "+49 30 7262250",
  contactPoint: {
    "@type": "ContactPoint",
    contactType: "customer support",
    telephone: "+49 30 7262250",
    availableLanguage: [
      "English",
      "German",
      "Turkish",
      "Portuguese",
      "Spanish",
      "French",
      "Italian",
      "Dutch",
      "Polish",
      "Romanian",
      "Russian",
      "Chinese",
      "Slovenian",
      "Danish",
      "Bulgarian",
    ],
  },
  areaServed: "Worldwide",
};

export default {
  name: "Home",
  components: {
    MainSection,
    HeroSection,
  },
  mounted() {
    const existing = document.getElementById(ORGANIZATION_SCHEMA_ID);
    if (existing) {
      existing.remove();
    }
    const script = document.createElement("script");
    script.id = ORGANIZATION_SCHEMA_ID;
    script.type = "application/ld+json";
    script.text = JSON.stringify(organizationSchema);
    document.head.appendChild(script);
  },
  beforeDestroy() {
    const el = document.getElementById(ORGANIZATION_SCHEMA_ID);
    if (el) {
      el.remove();
    }
  },
};
</script>
